import { Breadcrumb, Button } from 'react-bootstrap';
import { Link, matchPath, useLocation, useNavigate } from 'react-router-dom';

// Mapa rota -> rótulo/pai, pedido por Jason 2026-09-19 ("breadcrumbs pra
// navegar mais fácil... botão voltar"). Não usa `useMatches` (isso exige
// um data router, `createBrowserRouter` — o app usa `<BrowserRouter>`
// simples) — em vez disso casa `location.pathname` contra esse mapa com
// `matchPath` (suporta os `:publicId` das rotas de edição) e sobe pela
// cadeia de `pai` até a raiz.
const ROTAS = [
  { path: '/imoveis', label: 'Imóveis' },
  { path: '/imoveis/novo', label: 'Novo imóvel', pai: '/imoveis' },
  { path: '/imoveis/:publicId', label: 'Editar imóvel', pai: '/imoveis' },
  { path: '/clientes', label: 'Clientes' },
  { path: '/clientes/novo', label: 'Novo cliente', pai: '/clientes' },
  { path: '/clientes/:publicId', label: 'Editar cliente', pai: '/clientes' },
  { path: '/leads', label: 'Leads' },
  { path: '/leads/:publicId', label: 'Detalhe do lead', pai: '/leads' },
  { path: '/usuarios', label: 'Usuários' },
  { path: '/usuarios/novo', label: 'Novo usuário', pai: '/usuarios' },
  { path: '/usuarios/:publicId', label: 'Editar usuário', pai: '/usuarios' },
  { path: '/empresas', label: 'Empresas' },
  { path: '/empresas/nova', label: 'Nova empresa', pai: '/empresas' },
  { path: '/empresas/:publicId', label: 'Editar empresa', pai: '/empresas' },
  { path: '/minha-empresa', label: 'Minha empresa' },
  { path: '/taxonomia', label: 'Taxonomia' },
  { path: '/feeds-xml', label: 'Feeds XML' },
  { path: '/perfil', label: 'Meu perfil' },
  { path: '/trocar-senha', label: 'Trocar senha' },
];

function encontrarRota(pathname) {
  return ROTAS.find((rota) => matchPath({ path: rota.path, end: true }, pathname));
}

function montarTrilha(pathname) {
  const trilha = [];
  let caminhoAtual = pathname;
  let rotaAtual = encontrarRota(caminhoAtual);
  while (rotaAtual) {
    trilha.unshift({ label: rotaAtual.label, path: caminhoAtual });
    if (!rotaAtual.pai) break;
    caminhoAtual = rotaAtual.pai;
    rotaAtual = encontrarRota(caminhoAtual);
  }
  // Dashboard sempre na raiz da trilha (exceto quando já estamos nela) —
  // não é uma "rota" no mapa acima porque `/` não tem outro pai possível.
  if (trilha.length > 0 && trilha[0].path !== '/') {
    trilha.unshift({ label: 'Dashboard', path: '/' });
  }
  return trilha;
}

export default function Breadcrumbs() {
  const location = useLocation();
  const navigate = useNavigate();
  const trilha = montarTrilha(location.pathname);

  // Na própria Dashboard a trilha fica vazia (não existe entrada pra "/"
  // no mapa) — não faz sentido mostrar breadcrumb/voltar ali.
  if (trilha.length === 0) return null;

  return (
    <div className="d-flex align-items-center flex-wrap gap-2 gap-md-3 mb-3">
      <Button variant="outline-secondary" size="sm" onClick={() => navigate(-1)}>
        ← Voltar
      </Button>
      <Breadcrumb className="mb-0">
        {trilha.map((item, i) => {
          const ehUltimo = i === trilha.length - 1;
          return (
            <Breadcrumb.Item
              key={item.path}
              linkAs={ehUltimo ? undefined : Link}
              linkProps={ehUltimo ? undefined : { to: item.path }}
              active={ehUltimo}
            >
              {item.label}
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
    </div>
  );
}
